import React from 'react'
import MenuLanguageFlag from './MenuLanguageFlag'
import {Link, useI18next} from 'gatsby-plugin-react-i18next'
import {BLOG, CASESTUDIES} from '../../../constants/routes'

const MenuLanguageItem = ({language, text, flagSource}) => {
    const {originalPath} = useI18next()

    const getHref = () => {
        if (language === 'pl') {
            return originalPath
        }
        if (originalPath.includes(BLOG)) {
            return '/'
        }
        if (originalPath.includes(CASESTUDIES)) {
            return CASESTUDIES
        }
        return originalPath
    }

    return (
        <Link className="navbar-item" to={getHref()} language={language}>
            {flagSource && (
                <span className="icon">
                    <MenuLanguageFlag src={flagSource} />
                </span>
            )}
            <span style={{marginLeft: '0.5rem'}} className="has-text-weight-normal">
                {text}
            </span>
        </Link>
    )
}

export default MenuLanguageItem
